<template>
  <div class="logistics" style="position: relative;height: 100vh;">
    <div
      class="header acea-row row-between row-top"
      v-for="cart in cartInfo"
      :key="cart.id"
    >
      <div class="pictrue">
        <img :src="cart.productInfo.image" />
      </div>
      <div class="text acea-row row-between">
        <div class="name line2">{{ cart.productInfo.store_name }}</div>
        <div class="money">
          <div>￥{{ cart.truePrice }}</div>
          <div>x{{ cart.cart_num }}</div>
        </div>
      </div>
    </div>
    <div class="no-express" v-if="!orderInfo.delivery_id.length">
      <img src="@assets/images/noExpress.png" />
    </div>

    <div v-else>
      <div
        style="display: flex;align-items: center; padding: 10px 20px;background-color: #fff; margin-top: 10px;"
      >
        <div style="display: flex;align-items: center;">
          <img
            src="@assets/images/company.png"
            style="width: 16px;height: 14px;margin-right: 8px;"
          />
          <div style="font-weight: bold;margin-right: 10px;">物流公司</div>
        </div>
        <div style="font-size: 14px;">{{ orderInfo.delivery_name }}</div>
      </div>

      <div style=" padding: 10px 0;background-color: #fff; margin-top: 10px;">
        <div style="display: flex;align-items: center;padding: 0 20px 15px;">
          <img
            src="@assets/images/tracking.png"
            style="width: 16px;height: 14px;margin-right: 8px;"
          />
          <div style="font-weight: bold;margin-right: 10px;">快递单号</div>
        </div>
        <div
          v-for="(item, index) in orderInfo.delivery_data"
          :key="index"
          style="padding: 14px 20px ;border-top: 1px solid #F4F5F5;display: flex;justify-content: space-between; align-items: center;"
        >
          <div style="text-align: center;width: 50%;">
            <div>{{ item.id }}</div>
            <div>{{ item.desc }}</div>
          </div>
          <div style="display: flex;">
            <div
              @click="copySerial(item.id)"
              style="font-size: 0.2rem;padding: 3px 5px; border: 1px solid #000; border-radius: 15px;margin-right: 15px;"
            >
              复制单号
            </div>
            <div
              @click="getExpressageInfo(item.id)"
              style="font-size: 0.2rem;padding: 3px 5px; border: 1px solid #000; border-radius: 15px;"
            >
              物流信息
            </div>
          </div>
        </div>
      </div>

      <div class="popContainer" v-if="isshow" @click="isshow = false"></div>

      <div v-if="isshow" class="dialog">
        <div class="title">
          物流信息
          <img
            src="@assets/images/close.png"
            style="width: 16px;height: 16px;position: absolute;right: 3%;top: 18%;"
            @click="isshow = false"
          />
        </div>
        <div v-if="activities.length > 0">
          <div style="display: flex;padding:10px 20px 0; ">
            <img
              style="width: 1.3rem;height: 1.3rem;border-radius: 5px;"
              :src="cartInfo[0].productInfo.image"
            />
            <div style="flex: 1;padding: 10px 20px;">
              <div
                style="display: flex;justify-content: space-between; align-items: center;margin-bottom: 15px;"
              >
                <div style="font-weight: bold;">
                  {{ expressDetails.status }}
                </div>
                <div
                  style="display: flex; font-size: 12px; color: #313131;"
                  @click="copySerial(expressDetails.delivery_id)"
                >
                  复制
                </div>
              </div>
              <div style="color: #313131;font-size: 12px;">
                {{ expressDetails.delivery_name }}：{{
                  expressDetails.delivery_id
                }}
              </div>
            </div>
          </div>
          <el-timeline style="padding: 25px;">
            <el-timeline-item
              v-for="(activity, index) in activities"
              :key="index"
              :color="activity.color"
            >
              <div
                v-if="index === 0"
                style="color: #ff0000;font-weight: bold;font-size: 0.3rem"
              >
                {{ activity.status }}
              </div>
              <div v-else style="color: #AAAAAA;font-size: 0.3rem">
                {{ activity.status }}
              </div>
              <div v-if="index === 0" style="margin: 10px 0; font-size: 0.2rem">
                {{ activity.context }}
              </div>
              <div
                v-else
                style="color: #AAAAAA; margin: 10px 0; font-size: 0.2rem"
              >
                {{ activity.context }}
              </div>
              <div style="font-size: 0.2rem;color: #AAAAAA;">
                {{ activity.time }}
              </div>
            </el-timeline-item>
          </el-timeline>
        </div>
        <div v-else>
          <el-empty :description="errorMsg"></el-empty>
        </div>
      </div>
    </div>

    <!-- <Recommend></Recommend> -->
  </div>
</template>
<script>
import { express, expressageInfo } from "@api/order";

const NAME = "Logistics";

export default {
  name: NAME,
  data: function() {
    return {
      id: this.$route.params.id,
      cartInfo: [],
      orderInfo: {},
      expressList: [],
      loaded: false,
      activities: [],
      isshow: false,
      expressDetails: "",
      errorMsg: ""
    };
  },
  watch: {
    $route(n) {
      if (n.name === NAME && this.$route.params.id !== this.id) {
        this.id = this.$route.params.id;
        this.getExpress();
      }
    }
  },
  created() {
    this.getExpress();
  },
  methods: {
    async getExpress() {
      if (!this.id) return this.$dialog.error("订单不存在");
      const res = await express(this.id);
      this.cartInfo = res.data.order.cartInfo;
      console.log(this.cartInfo);
      this.orderInfo = res.data.order;
    },

    // 复制单号
    copySerial(text) {
      var input = document.createElement("input"); // 创建input对象
      input.value = text; // 设置复制内容
      document.body.appendChild(input); // 添加临时实例
      input.select(); // 选择实例内容
      document.execCommand("Copy"); // 执行复制
      document.body.removeChild(input); // 删除临时实例
      this.$dialog.success("复制成功");
    },

    // 查看物流信息
    getExpressageInfo(no) {
      this.activities = [];
      console.log(no, this.id);
      const params = {
        order_id: this.id,
        no
      };
      expressageInfo(params).then(res => {
        this.isshow = true;
        this.activities = res.data ? res.data.list : [];
        this.errorMsg = res.msg ? res.msg : "";
        this.expressDetails = res.data;
      });
    }
  }
};
</script>

<style scoped>
.popContainer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 99;
}
.dialog {
  width: 6.5rem;
  height: 10rem;
  background-color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
  overflow: auto;
  overflow-x: hidden;
  border-radius: 10px;
}

.dialog::-webkit-scrollbar {
  display: none;
}

.title {
  height: 0.9rem;
  line-height: 0.9rem;
  text-align: center;
  color: #fff;
  background-color: #ff0000;
  position: relative;
}

.no-express {
  margin: 1.5rem 0;
}

.no-express img {
  width: 6rem;
  margin: 0 auto;
  display: block;
}
</style>
